import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {MatButtonModule} from '@angular/material/button';
import {MatIconModule} from '@angular/material/icon';
import {MatTooltipModule} from '@angular/material/tooltip';
import {AltAccessibilityModule} from 'app/accessibility/alt-accessibility/alt-accessibility.module';
import {CarsErrorHandlingModule} from 'app/error-handling/cars-error-handling.module';
import {StandardFormatGroupCreatorComponent} from './standard-format-group-creator.component';
import {StandardFormatGroupModalModule} from './standard-format-group-modal/standard-format-group-modal.module';

@NgModule({
  imports: [
    CommonModule,
    MatButtonModule,
    MatTooltipModule,
    MatIconModule,
    AltAccessibilityModule,
    CarsErrorHandlingModule,
    StandardFormatGroupModalModule,
  ],
  declarations: [StandardFormatGroupCreatorComponent],
  exports: [StandardFormatGroupCreatorComponent],
})
export class StandardFormatGroupCreatorModule {}
